import React, { Component } from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip
} from 'recharts';
import styled from 'styled-components';
import { get } from 'lodash';

const ChartContainer = styled.div`
  .chartContainer {
    margin-top: 25px;
  }

  svg .recharts-label-list tspan {
    fill: white !important;
  }
`;

const BarGraphContainer = styled.div`
  font-family: ${(props) => props.theme.fonts.sfcompact_text};
  min-height: 150px;
  position: relative;
  .recharts-cartesian-axis-tick text {
    fill: #212529;
    font-size: 12px;
  }

  .label {
    width: 80px;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .tooltipContent {
    background-color: white;
    padding: 10px;
  }
`;

export default class SimpleVerticalBarGraph extends Component {
  constructor(props) {
    super(props);
  }

  renderCustomToolTip(data) {
    return (
      <div className="tooltipContent">
        {get(data, 'payload[0].payload.name')}:{' '}
        {get(data, 'payload[0].payload.value')}
      </div>
    );
  }

  render() {
    const formattedData = this.props.data;
    return (
      <ChartContainer>
        <div className="chartContainer">
          <BarGraphContainer>
            <ResponsiveContainer width="100%" minHeight={500}>
              <BarChart
                data={formattedData}
                layout="vertical"
                barCategoryGap={16}
                barGap={16}
              >
                <CartesianGrid horizontal={false} stroke="#e4e4e4" />
                <YAxis
                  type="category"
                  dataKey="name"
                  width={200}
                  tickLine={false}
                  tickFormatter={(value) =>
                    value.length > 16 ? value.slice(0, 16) + '...' : value
                  }
                  label={(props) => <div width={30}>{props.text}</div>}
                />
                <XAxis
                  axisLine={false}
                  tickCount={5}
                  interval="preserveStart"
                  scale="linear"
                  tickFormatter={(value) => value}
                  type="number"
                  domain={[0, (dataMax) => dataMax + dataMax / 4]}
                  tickLine={true}
                  dataKey="value"
                />
                <Tooltip content={this.renderCustomToolTip.bind(this)} />
                <Bar
                  isAnimationActive={false}
                  barSize={30}
                  dataKey={'value'}
                  fill="#2b3d54"
                  label={{
                    position: 'insideRight',
                    fill: '#e4e4e4',
                    offset: 10
                  }}
                />
              </BarChart>
            </ResponsiveContainer>
          </BarGraphContainer>
        </div>
      </ChartContainer>
    );
  }
}
